export var extractType = function extractType(jsonLd) {
  var type = jsonLd['@type'];
  if (type) {
    if (Array.isArray(jsonLd['@type'])) {
      return type;
    } else {
      return [type];
    }
  }
};